module.exports = __webpack_public_path__ + "img/mozilla.51de8106.png";